/*
 * Copyright (c) 2017 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs/Observable';
import { Point } from '../models/point.model';
import * as _ from 'lodash';
import { environment } from '../../environments/environment';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class PointService {
    api_url: any;

    constructor(private apiService: ApiService) {
        this.api_url = environment.cdt.api_url;
    }

    listAll(siteId: String, roleLabel?: string, unmapped?: boolean, withRoles?: boolean): Observable<[Point]> {
        let params = new HttpParams();
        if (!_.isNil(roleLabel)) {
            params = params.set('roleLabel', roleLabel);
        }
        if (!_.isNil(unmapped)) {
            params = params.set('unmapped', String(unmapped));
        }
        if (!_.isNil(withRoles)) {
            params = params.set('withRoles', String(withRoles));
        }
        return this.apiService.get('sites/' + siteId + '/points', this.api_url, params);
    }

    getCount(siteId: string, unmapped?: boolean): Observable<any> {
        let params = new HttpParams();
        if (!_.isNil(unmapped)) {
            params = params.set('unmapped', String(unmapped));
        }
        return this.apiService.get('sites/' + siteId + '/points/count', this.api_url, params);
    }

    movePoints(siteId: string, assetIri: string, points: Array<Point>) {
        const reducedPoints = points.map(this.reducePoint);
        return this.apiService.post('sites/' + siteId + '/points/move-points', this.api_url, JSON.stringify({
            assetIri: assetIri,
            points: reducedPoints
        }));
    }

    private reducePoint(point: Point) {
        const newPoint = new Point();
        newPoint.iri = point.iri;
        return newPoint;
    }

    assignRole(siteId: string, roleLabel: string, points: Array<Point>) {
        const reducedPoints = points.map(this.reducePoint);
        return this.apiService.post('sites/' + siteId + '/points/assign-role', this.api_url, JSON.stringify({
            roleLabel: roleLabel,
            points: reducedPoints
        }));
    }

    unassignRole(siteId: string, points: Array<Point>) {
        const reducedPoints = points.map(this.reducePoint);
        return this.apiService.post('sites/' + siteId + '/points/unassign-role', this.api_url, JSON.stringify({
            points: reducedPoints
        }));
    }

    getInvalidPointsForRole(siteId: string, roleLabel: string, points: Array<Point>) {
        const reducedPoints = points.map(this.reducePoint);
        return this.apiService.post('sites/' + siteId + '/points/invalid-points', this.api_url, JSON.stringify({
            roleLabel: roleLabel,
            points: reducedPoints
        }));
    }
}
